import api from "./Api";

class VersaoTabelaIbptService {
  GetVersaoTabelaIbpt(payload) {
    return api.get("/v1/versaoTabelaIbpt/" + payload).then((response) => {
      return response.data;
    });
  }

  PostVersaoTabelaIbpt(payload) {
    return api.post("/v1/versaoTabelaIbpt/", payload).then((response) => {
      return response.data;
    });
  }

  PutVersaoTabelaIbpt(payload) {
    return api.put("/v1/versaoTabelaIbpt/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteVersaoTabelaIbpt(payload) {
    return api.delete("/v1/versaoTabelaIbpt/" + payload).then((response) => {
      return response.data;
    });
  }

  GetVersaoTabelaIbptOData(payload) {
    return api.get("/OData/VersaoTabelaIbpt" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new VersaoTabelaIbptService();
